import { Button } from 'antd';
import { FC, ReactElement, memo } from 'react';
import { PlusCircle } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { useAppPagination } from '@/common/hooks';
import { AppRoutes } from '@/common/interfaces';
import { CommonContainerTitle, FallbackedLayout } from '@/common/layouts';

import { useGetAllReferralsQuery } from '@/modules/Sites';

import { ReferralsListView } from './ReferralsListView';

interface Props {
  siteId: string;
}

export const ReferralsListContainer: FC<Props> = memo(({ siteId }) => {
  const { pageParam: currentPage, handleChangePage } = useAppPagination();

  const {
    data: referralsListData,
    error: referralsListError,
    isLoading: isReferralsListLoading,
    isFetching: isReferralsListFetching,
    isError: isReferralsListError
  } = useGetAllReferralsQuery(siteId, { page: currentPage })();

  return (
    <FallbackedLayout
      isLoading={ isReferralsListLoading }
      error={ referralsListError }
      isError={ isReferralsListError }
      data={ referralsListData }
    >
      { (referralsList): ReactElement => (
        <>
          <CommonContainerTitle
            onlyExtra
            extra={
              <Link to={ AppRoutes.ReferralsCreate.replace(':siteId', siteId) }>
                <Button icon={ <PlusCircle/> } type="primary">
                  Створити реферал
                </Button>
              </Link>
            }
          />

          <ReferralsListView
            siteId={ siteId }
            currentPage={ currentPage }
            referralsListItems={ referralsList.items }
            referralsListTotalItems={ referralsList.meta.totalItems }
            referralsListItemsPerPage={ referralsList.meta.itemsPerPage }
            isLoading={ isReferralsListFetching }
            handleChangePage={ handleChangePage }
          />
        </>
      ) }
    </FallbackedLayout>
  );
});
